import { HttpContext } from '@angular/common/http'
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { I18NService } from '@core'
import { ALLOW_ANONYMOUS } from '@delon/auth'
import { _HttpClient, TitleService, ALAIN_I18N_TOKEN } from '@delon/theme'
import { MatchControl } from '@delon/util/form'
import { environment } from '@env/environment'
import { NzSafeAny } from 'ng-zorro-antd/core/types'
import { NzMessageService } from 'ng-zorro-antd/message'
import { finalize, interval, take } from 'rxjs'
const { msUrl } = environment.api

@Component({
  selector: 'passport-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.less'],
})
export class UserResetComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: _HttpClient,
    private cdr: ChangeDetectorRef,
    private message: NzMessageService,
    private titleSrv: TitleService,
    @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
  ) {}

  ngOnInit(): void {
    this.titleSrv.setTitle(this.i18n.fanyi('app.login.forgot-password'))
  }

  form = this.fb.nonNullable.group(
    {
      password: [
        '',
        [Validators.required, Validators.minLength(6), UserResetComponent.checkPassword.bind(this)],
      ],
      confirm: ['', [Validators.required, Validators.minLength(6)]],
      mobilePrefix: ['+86'],
      mobile: ['', [Validators.required, Validators.pattern(/^1\d{10}$/)]],
      captcha: ['', [Validators.required]],
    },
    {
      validators: MatchControl('password', 'confirm'),
    },
  )
  error = ''
  loading = false
  visible = false
  status = 'pool'
  progress = 0
  passwordProgressMap: { [key: string]: 'success' | 'normal' | 'exception' } = {
    ok: 'success',
    pass: 'normal',
    pool: 'exception',
  }

  static checkPassword(control: FormControl): NzSafeAny {
    if (!control) {
      return null
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self: NzSafeAny = this
    self.visible = !!control.value

    if (control.value && control.value.length > 9) {
      self.status = 'ok'
    } else if (control.value && control.value.length > 5) {
      self.status = 'pass'
    } else {
      self.status = 'pool'
    }

    if (self.visible) {
      self.progress = control.value.length * 10 > 100 ? 100 : control.value.length * 10
    }
  }

  count = 0
  getCaptcha(): void {
    const mobile = this.form.controls.mobile
    if (mobile.invalid) {
      mobile.markAsDirty({ onlySelf: true })
      mobile.updateValueAndValidity({ onlySelf: true })
      return
    }

    this.http
      .get(`${msUrl.auth}/captcha/key`, null, {
        context: new HttpContext().set(ALLOW_ANONYMOUS, true),
      })
      .subscribe((res) => {
        if (res.successful) {
          const { message } = res
          this.http
            .get(
              `${msUrl.auth}/captcha/phone`,
              {
                phoneNumber: mobile.value,
                captchaKey: message,
              },
              {
                context: new HttpContext().set(ALLOW_ANONYMOUS, true),
              },
            )
            .subscribe((res) => {
              if (res.successful) {
                const { data } = res
                const { expire } = data
                this.count = 60 // expire
                const numbers = interval(1000)
                const takeNumbers = numbers.pipe(take(this.count))
                takeNumbers.subscribe((x) => {
                  this.count = this.count - 1
                })
              }
            })
        }
      })
  }

  submit(): void {
    this.error = ''
    Object.keys(this.form.controls).forEach((key) => {
      const control = (this.form.controls as NzSafeAny)[key] as AbstractControl
      control.markAsDirty()
      control.updateValueAndValidity()
    })
    if (this.form.invalid) {
      return
    }

    const preRequest = () => {
      this.loading = true
      this.cdr.detectChanges()
    }

    const afterRequest = () => {
      this.loading = false
      this.cdr.detectChanges()
    }

    const { password: newPassword, mobile, captcha } = this.form.value
    const body = { newPassword, mobile, captcha }
    const options = {
      context: new HttpContext().set(ALLOW_ANONYMOUS, true),
    }

    preRequest()
    this.http
      .put(`${msUrl.auth}/users/changePassword`, body, null, options)
      .pipe(finalize(afterRequest))
      .subscribe((res) => {
        const { successful } = res
        if (!successful) {
          this.error = res.message
          this.cdr.detectChanges()
          return
        }

        this.message.create('success', '密码重置成功')
        this.router.navigateByUrl('/passport/login')
      })
  }
}
